import $ from 'jquery';

/*
* delayKeyup
* http://code.azerti.net/javascript/jquery/delaykeyup.htm
* Inspired by CMS in this post : http://stackoverflow.com/questions/1909441/jquery-keyup-delay
* Written by Gaten
* Exemple : $("#input").delayKeyupChange(function(){ alert("5 secondes passed from the last event keyup."); }, 5000);
*/
$.fn.delayKeyupChange = function (callback, ms) {
    var timer = 0,
        that = this,
        $this = $(this),
        lastSearch = $this.val();

    $this.on('keyup change', function () {
        var $this = $(this);
        var searchStr = $this.val();

        if (searchStr != lastSearch) {
            lastSearch = searchStr;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.call(that);
            }, ms);
        }
    });

    return $this;
};